import { useState, useEffect } from "react";

const navItems = [
  { label: "Processing", href: "#processing" },
  { label: "Services", href: "#services" },
  { label: "Local Area", href: "#local-area" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Comparison", href: "#comparison" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
  { label: "Resources", href: "#local-resources" },
];

export default function BossierCityStickyNav() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`w-full z-50 transition-all duration-300 ${isSticky ? "fixed top-0 left-0 shadow-lg" : "relative"}`}>
      <div className="bg-[#1A365D] border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between gap-4 overflow-x-auto scrollbar-hide">
            <div className="flex items-center gap-1 flex-shrink-0">
              {navItems.map((item) => (
                <a key={item.href} href={item.href} className="px-3 py-4 text-white/60 hover:text-white text-xs font-semibold uppercase tracking-wide transition-colors whitespace-nowrap border-b-2 border-transparent hover:border-[#F6C344]">
                  {item.label}
                </a>
              ))}
            </div>
            <a href="https://fastpassportcenter.com/checkout/" className="flex-shrink-0 inline-flex items-center gap-1.5 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-xs px-4 py-2 rounded-md transition-all whitespace-nowrap">
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}